var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42857 0C1.98594 0 0 1.98594 0 4.42857V26.5714C0 29.0141 1.98594 31 4.42857 31H26.5714C29.0141 31 31 29.0141 31 26.5714V4.42857C31 1.98594 29.0141 0 26.5714 0H4.42857ZM4.77455 11.7772H9.37612V26.5714H4.77455V11.7772ZM9.73594 7.09263C9.73594 8.56652 8.54576 9.7567 7.07187 9.7567C5.59799 9.7567 4.40781 8.56652 4.40781 7.09263C4.40781 5.61875 5.59799 4.42857 7.07187 4.42857C8.54576 4.42857 9.73594 5.61875 9.73594 7.09263ZM21.9975 26.5714V19.375C21.9975 17.6589 21.9629 15.4516 19.6103 15.4516C17.2161 15.4516 16.8493 17.3199 16.8493 19.2504V26.5714H12.2547V11.7772H16.6625V13.7978H16.7248C17.3406 12.6353 18.8422 11.4105 21.0772 11.4105C25.7272 11.4105 26.5922 14.4759 26.5922 18.4616V26.5714H21.9975Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ad912cb3625742a2aac2179f4aa3071c.svg";
export { ForwardRef as ReactComponent };